import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"


class IndexAdmin extends Component {




  render() {
    return (
      <React.Fragment>
          <Header />

      </React.Fragment>
       
    );
  }
}

export default withRouter(IndexAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/index.js